/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";
import { AIRLINES } from "../../constants/appConstants";

/* Components */
import ProfileTabAA from "./profileTabAA";
import ProfileTabUC from "./profileTabUC";
import ProfileTabAS from "./profileTabAS";
import ProfileTabAM from "./profileTabAM";
import ProfileTabCHOICE from './profileTabCHOICE';
import ProfileTabAC from './profileTabAC';

/* Styles */
import styles from "./styles.js"

const ProfileTabbedNav = ({travelerDetails}) => {
  
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const renderProfileTab = () => {
    switch (providerCode) {
      case AIRLINES.AA:
        return <ProfileTabAA travelerDetails={travelerDetails}/>;
      case AIRLINES.UC:
        return <ProfileTabUC travelerDetails={travelerDetails}/>;
      case AIRLINES.AS:
        return <ProfileTabAS travelerDetails={travelerDetails}/>;
      case AIRLINES.AM:
        return <ProfileTabAM travelerDetails={travelerDetails}/>;
      case AIRLINES.CHOICE:
        return <ProfileTabCHOICE travelerDetails={travelerDetails}/>;
      case AIRLINES.AC:
        return <ProfileTabAC travelerDetails={travelerDetails}/>;
    }
  }

  return (
    travelerDetails &&
    <div className={classes.profileTabbedNav}>
      <Tabs
        defaultActiveKey={ "profile" }
        id="profile-page-tabs"
        className={ classes.tabs }
      >
        <Tab eventKey="profile" title={<FormattedMessage id="profile.title" />}>
          { renderProfileTab() }
        </Tab>
      </Tabs>
    </div>
  )
}

export default ProfileTabbedNav;
